import { render } from "./VModal.vue?vue&type=template&id=29ca8ac6&scoped=true"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"

import "./VModal.vue?vue&type=style&index=0&id=29ca8ac6&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ca8ac6"]])

export default __exports__